<template>
	<div class="main-content">
		<Header />
		<div class="page-content" :class="categoryPickerClass">
			<div class="top-page container">
				<CategoryPicker :categoryActive="categoryActive" />
				<h1>Nos derniers articles de blog</h1>
			</div>
			<div class="content container">
				<div class="container-post-cards">
					<PostCard v-for="post in posts" :key="post.id" :post="post" :idCategory="idCategory" />
				</div>
				<Sidebar />
			</div>
			<div class="container container-pagination">
				<Pagination :total_posts="nb_posts" :per_page="per_page" />
			</div>
			<div id="inscription-newsletter" class="container bloc-newsletter">
				<div class="newsletter">
					<div class="content">
						<div class="container-texte">
							<span class="en-tete">Restez informé avec la newsletter des</span>
							<span class="titre">GRETA-CFA Pays de la Loire</span>
							<img src="@img/arrow_white.png" alt="Logo Académie de Nantes" />
						</div>
						<div class="container-input">
							<button class="submit-btn" :class="newsletterSubscriptionSuccess" @click="subscribeToNewsletter">Je m’inscris</button>
							<input type="email" placeholder="Votre adresse email" v-model="email" />
						</div>
						<div class="container-confirmation">
							<span v-if="confirmation">Votre inscription à la newsletter a bien été prise en compte.<br/> Un mail de confirmation vous a été envoyé</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
		<Loader v-if="isLoading" />
	</div>
</template>

<script>
import { EventBus } from '@core/event-bus';

import Loader from '@components/global/Loader';
import Header from '@components/global/Header';
import Footer from '@components/global/Footer';
import Pagination from '@components/global/Pagination';

import PostCard from '@components/post/Post-card';
import CategoryPicker from '@components/post/category-picker';

import Sidebar from '@components/sidebar/Sidebar';

/**
 * Template de posts permettant d'afficher tous les articles du blog
 */
export default {
	data() {
		return {
			posts: [],
			isLoading: true,
			categoryPickerActive: false,
			categoryPickerClass: '',
			nb_posts: 0,
			idCategory: undefined,
			per_page: 7,
			categoryActive: undefined,
			email: '',
			newsletterSubscriptionSuccess: '',
			confirmation: false,
		};
	},
	created() {
		EventBus.$on('category-picker_category-item_clicked', (category) => {
			this.idCategory = category.idCategory;
			this.getPostsFromApi(category.idCategory, category.categoryName);
		});

		EventBus.$on('menu-burger_hamRotate_clicked', (categoryPickerActive) => {
			this.categoryPickerActive = categoryPickerActive;
			this.categoryPickerClass = this.categoryPickerActive ? 'active' : '';
		});

		//si pas de sticky on met le prmeier de la liste en "faux sticky" c-a-d style sticky sans le bouton "Article à la une"
		EventBus.$on('posts_posts-loaded', () => {
			let isSticky = this.posts.some((post) => {
				return post.sticky;
			});

			if (!isSticky) this.posts[0].falseSticky = true;
			// Si on a une ancre, on scroll dessus une fois que les posts sont chargés, car ils décalent la position des éléments dans la page
			if(window.location.hash){
				this.$nextTick(function () {
					var element = document.querySelector(window.location.hash);
					element.scrollIntoView();
				});
			}
		});

		EventBus.$on('pagination_item-pagination_click', (index) => {
			this.getPostsFromApi(this.idCategory, undefined, this.per_page, index);
		});
	},
	mounted() {
		this.isLoading = false;
		if (typeof fromPhp_categoryActive !== 'undefined')
			this.categoryActive = parseInt(fromPhp_categoryActive);
		else this.getPostsFromApi();
	},
	methods: {
		getPostsFromApi(idCategory = undefined, categoryName = undefined, per_page = 7, page = 1) {
			this.isLoading = true;
			$api.getPosts(idCategory, per_page, page).then((res) => {
				this.posts = res.data;
				this.nb_posts = parseInt(res.headers['x-wp-total']);
				this.isLoading = false;

				EventBus.$emit('posts_posts-loaded');
			});
		},
		subscribeToNewsletter() {
			var re = /[^@]+@[^@]+\.[^@]+/;

			if(re.test(this.email)){
				let comp = this;
				var xhr = new XMLHttpRequest();
				xhr.open("POST", "/wp-admin/admin-ajax.php?action=addNewsletterSubscriber");
				xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
				xhr.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						if(this.responseText == 0){
							comp.newsletterSubscriptionSuccess = 'success';
							comp.confirmation = true;
							setTimeout(function () {
									comp.newsletterSubscriptionSuccess = '';
							}, 4000);
						}else{
							if(this.responseText == 1 || this.responseText == 2){
								alert('Une erreur s\'est produite lors de l\'ajout de votre adresse email');
							}else if(this.responseText == 3){
								alert('Format d\'adresse mail invalide');
							}
						}
					}
				};
				xhr.send('email=' + encodeURIComponent(this.email));
			}
		},
	},
	computed: {
		getPosts() {
			return this.posts;
		},
	},
	components: {
		Loader,
		PostCard,
		Sidebar,
		Header,
		Footer,
		Pagination,
		CategoryPicker,
	},
};
</script>

<style lang="scss">
@import '~@scss/style.scss';

@keyframes success {
    25% {
        background-color: #25C62B;
    }
    to {
        background-color: $secondaryColor;
    }
}

.page-content {
	position: relative;
	background-color: #efefef;
	padding-bottom: 60px;

	@media screen and (max-width: $break-large) {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	@media screen and (max-width: $break-medium) {
		padding-top: 0;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 430px;
		z-index: 0;
		background-color: $mainColor;
		transition: all 0.3s ease-in-out;
	}

	&.active::before {
		height: 660px;
	}

	& > * {
		z-index: 1;
	}

	.top-page {
		position: relative;
		top: -65px;

		h1 {
			margin-top: 45px;
		}
	}

	.content {
		display: grid;
		grid-template-columns: 70% 30%;
		gap: 0 25px;

		@media screen and (max-width: $break-large) {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.sidebar {
				margin-top: 50px;
			}
		}

		.container-post-cards {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 20px 25px;

			@media screen and (max-width: $break-tablet) {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;

				.post-card + .post-card {
					margin-top: 20px;
				}
			}
		}
	}

	.container-pagination {
		.pagination {
			margin: 60px 0;
			margin-right: 30%;

			@media screen and (max-width: $break-large) {
				order: -1;
				margin-right: 0;
			}
		}
	}

	.bloc-newsletter {
		.newsletter {
			width: 100%;
			height: 315px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			padding-top: 60px;
			padding-bottom: 50px;
			background-image: url('../assets/img/newsletter.jpg');
			background-size: cover;
			background-position: center;
			border-radius: 20px;
			overflow: hidden;

			@media screen and (max-width: $break-tablet) {
				height: auto;
				padding-top: 160px;
				background-image: url('../assets/img/newsletter-mobile.jpg');
			}

			.content {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				width: 560px;
				color: white;

				@media screen and (max-width: $break-tablet) {
					width: 95%;
				}

				.en-tete {
					font-size: 20px;
					font-weight: 300;

					@media screen and (max-width: $break-tablet) {
						text-align: center;
						line-height: 25px;
					}
				}

				.titre {
					line-height: 1;
					font-size: 30px;
					font-weight: bold;
					font-style: italic;

					@media screen and (max-width: $break-tablet) {
						text-align: center;
						line-height: 30px;
					}
				}
			}

			.container-texte {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				padding: 0 60px 70px 60px;
				position: relative;

				img {
					position: absolute;
					bottom: 0;
					right: 0;

					@media screen and (max-width: $break-tablet) {
						display: none;
					}
				}

				@media screen and (max-width: $break-tablet) {
					padding: 0 30px 110px 30px;
				}
			}

			.container-input {
				position: relative;
				width: 100%;
				height: 60px;
				margin-top: 25px;

				@media screen and (max-width: $break-tablet) {
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column-reverse;
					height: auto;
					margin-top: 40px;
					padding-bottom: 0;
				}

				.submit-btn {
					position: absolute;
					right: 4px;
					top: 50%;
					transform: translateY(-50%);
					width: 220px;
					height: 50px;
					display: inline-flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					white-space: nowrap;
					font-size: 20px;
					font-family: $mainFont;
					font-style: italic;
					line-height: 1;
					text-decoration: none;
					border: 2px solid transparent;
					border-radius: 50px;
					cursor: pointer;
					color: white;
					background-color: $secondaryColor;
					outline: none;
					transition: all 0.3s ease-in-out;

					&:hover {
						@media screen and (min-width: $break-tablet + 1) {
							background-color: $mainColor;
						}
					}

					&.success {
						animation: success 4s normal forwards ease-in-out;
						animation-iteration-count: 1;
					}

					@media screen and (max-width: $break-tablet) {
						width: 230px;
						height: 60px;
						position: static;
						transform: none;
						margin-top: 20px;
						border-color: white;
					}
				}

				input {
					width: 100%;
					height: 100%;
					padding-left: 30px;
					padding-right: 230px;
					padding-top: 6px;
					font-size: 18px;
					background-color: white;
					color: $mainColor;
					border-radius: 50px;
					border: none;
					outline: none;

					@media screen and (max-width: $break-tablet) {
						padding: 0 5px;
						height: 60px;
					}

					&::placeholder {
						font-size: 20px;
						color: $mainColor;
						font-style: italic;
						font-weight: bold;
						text-align: center;
					}
				}
			}

			.container-confirmation{
				padding-top: 5px;
				font-size: 13px;
				font-size: 15px;
				display: inline-block;
			}
		}
	}
}

header.page-header {
	height: 360px;

	.logo-container {
		margin-top: 60px;
	}
}
</style>


// WEBPACK FOOTER //
// src/views/posts.vue